"use strict";

var PropTypes = require("prop-types");

var PledgeActions = require("../actions/PledgeActions");
var PledgeStore = require("../stores/PledgeStore");

var GiftArray = require("../projectComponents/GiftArray");

class PledgeGiftArray extends React.Component {
	render() {
		return (
			<GiftArray
				{...this.props}
				beginningComponentName="Pledge"
				thisArg={this}
				tangibleActions={PledgeActions}
				tangibleStore={PledgeStore}
				tangibleType="pledge"
				displayCodeProperty="PledgeCode"
				reactComponentCategory="PledgeGiftArrayComponents"
			/>
		);
	}
}

PledgeGiftArray.defaultProps = {
	includeCurrencySymbol: true,
	includeOther: false,
	otherText: "Other",
	showDecimals: true
};

PledgeGiftArray.propTypes = {
	buttonStyle: PropTypes.object,
	childClass: PropTypes.string,
	context: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	giftAmounts: PropTypes.array,
	hideWhenSubaccounts: PropTypes.bool,
	includeCurrencySymbol: PropTypes.bool,
	includeOther: PropTypes.bool,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	minimumAmount: PropTypes.number,
	otherText: PropTypes.string,
	pledge: PropTypes.object,
	showDecimals: PropTypes.bool,
	theme: PropTypes.string,
	type: PropTypes.oneOf(["button", "radio", "dropdown"]).isRequired
};

module.exports = PledgeGiftArray;
